import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { signUp } from "@/backend.api";
import identityResult from "@/models/identityResult";
import {
    useMessage,
    NInput,
    NInputGroup,
    NInputGroupLabel,
    NFormItem,
    NButton,
    NResult,
    NForm,
    NCheckbox,
    NText,
    NModal,
    NScrollbar,
    NSpace,
    FormItemRule
} from "naive-ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const formRef = ref(null) as any;
const message = useMessage();
let isLoading = ref(false);
let isFinished = ref(false);
let showPrivacyPolicyModal = ref(false);

const size = ref("medium");

const formValue = ref({
    name: "",
    phone: "",
    email: "",
    city: "",
    agreementAccepted: false
});

const rules = {
    name: {
        required: true,
        message: "Обязательно",
        trigger: ["input"]
    },
    email: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        type: "email"
    },
    phone: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        validator: (_rule: FormItemRule, value: string) => {
            return /^\d{10,12}$/.test(value);
        }
    },
    city: {
        required: true,
        message: "Обязательно",
        trigger: ["input"],
        type: "text",
        validator: (_rule: FormItemRule, value: string) => {
            return value.length > 0;
        }
    },
    agreementAccepted: {
        required: true,
        message: "Необходимо дать согласие",
        trigger: ["change"],
        validator: (_rule: FormItemRule, value: boolean) => {
            return value === true;
        }
    }
};

const showPrivacyPolicy = () => {
    showPrivacyPolicyModal.value = true;
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    formRef.value?.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            debugger;
            const promise = signUp(formRef.value.model);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(NForm), {
      className: "form",
      ref_key: "formRef",
      ref: formRef,
      model: formValue.value,
      "show-label": true,
      rules: rules,
      size: "medium"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NFormItem), {
          path: "name",
          label: "Имя"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formValue.value.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formValue.value.name) = $event)),
              size: "medium",
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), {
          path: "phone",
          label: "Телефон"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInputGroup), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NInputGroupLabel), { size: "medium" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("+", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(NInput), {
                  value: formValue.value.phone,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formValue.value.phone) = $event)),
                  size: "medium",
                  placeholder: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), {
          path: "email",
          label: "Почта"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formValue.value.email,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formValue.value.email) = $event)),
              size: "medium",
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), {
          path: "city",
          label: "Город"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formValue.value.city,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formValue.value.city) = $event)),
              size: "medium",
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), { path: "agreementAccepted" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCheckbox), {
              checked: formValue.value.agreementAccepted,
              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((formValue.value.agreementAccepted) = $event)),
              size: "medium"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NText), null, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode(" Даю согласие на ", -1)),
                    _createVNode(_unref(NText), {
                      type: "primary",
                      onClick: showPrivacyPolicy,
                      style: {"text-decoration":"underline","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" обработку персональных данных ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          size: "medium",
          block: "",
          strong: "",
          loading: _unref(isLoading),
          disabled: !formValue.value.agreementAccepted,
          type: "primary",
          onClick: handleSubmitButton
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Зарегистрироваться ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      _: 1
    }, 8, ["model"]), [
      [_vShow, !_unref(isFinished)]
    ]),
    _withDirectives(_createVNode(_unref(NResult), {
      size: "medium",
      status: "success",
      title: "Регистрация прошла успешно",
      description: "На вашу почту отправлено сообщение с информацией для входа."
    }, {
      footer: _withCtx(() => [...(_cache[11] || (_cache[11] = [
        _createElementVNode("div", null, "Не приходит письмо? Проверьте папку «Спам»", -1)
      ]))]),
      _: 1
    }, 512), [
      [_vShow, _unref(isFinished)]
    ]),
    _createVNode(_unref(NModal), {
      show: _unref(showPrivacyPolicyModal),
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showPrivacyPolicyModal) ? (showPrivacyPolicyModal).value = $event : showPrivacyPolicyModal = $event)),
      preset: "card",
      title: "Согласие на обработку персональных данных",
      style: {"width":"700px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(NButton), {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showPrivacyPolicyModal) //@ts-ignore
 ? showPrivacyPolicyModal.value = false : showPrivacyPolicyModal = false))
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode(" Закрыть ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(NScrollbar), { style: {"max-height":"500px"} }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSpace), {
              vertical: "",
              size: 16
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NText), null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("p", null, " Настоящим, оставляя свои персональные данные на сайте vin-kode.ru (и его поддомены) (далее — Сайт), я, действуя свободно, своей волей и в своем интересе, подтверждаю свое согласие на обработку моих персональных данных в соответствии с Федеральным законом Российской Федерации от 27.07.2006 № 152-ФЗ «О персональных данных». ", -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "1. Перечень персональных данных")
                    ], -1),
                    _createElementVNode("p", null, " Я даю согласие на обработку следующих персональных данных, которые могут быть предоставлены мной через формы на Сайте, включая, но не ограничиваясь: ", -1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, "имя;"),
                      _createElementVNode("li", null, "номер телефона;"),
                      _createElementVNode("li", null, "адрес электронной почты;"),
                      _createElementVNode("li", null, "иные данные, указанные мной добровольно при использовании Сайта.")
                    ], -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "2. Цели обработки персональных данных")
                    ], -1),
                    _createElementVNode("p", null, "Обработка персональных данных осуществляется в целях:", -1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, "обработки запросов, заявок и обращений;"),
                      _createElementVNode("li", null, "предоставления услуг и информации;"),
                      _createElementVNode("li", null, "осуществления обратной связи;"),
                      _createElementVNode("li", null, "исполнения договорных обязательств;"),
                      _createElementVNode("li", null, "направления информационных и рекламных сообщений;"),
                      _createElementVNode("li", null, "улучшения качества работы Сайта.")
                    ], -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "3. Действия с персональными данными")
                    ], -1),
                    _createElementVNode("p", null, "Я даю согласие на совершение следующих действий с моими персональными данными:", -1),
                    _createElementVNode("p", null, " сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), использование, передача (в случаях, предусмотренных законодательством РФ), обезличивание, блокирование, удаление и уничтожение. ", -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "4. Срок действия согласия")
                    ], -1),
                    _createElementVNode("p", null, " Настоящее согласие действует с момента его предоставления и до момента его отзыва Пользователем. ", -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "5. Отзыв согласия")
                    ], -1),
                    _createElementVNode("p", null, " Я уведомлен(а), что согласие на обработку персональных данных может быть отозвано мной в любой момент путем направления письменного уведомления Администрации Сайта на электронную почту, указанную в разделе «Помощь» на Сайте. ", -1),
                    _createElementVNode("h3", null, [
                      _createElementVNode("strong", null, "6. Заключительные положения")
                    ], -1),
                    _createElementVNode("p", null, " Я подтверждаю, что ознакомлен(а) с Политикой конфиденциальности сайта vin-kode.ru (и его поддомены), понимаю свои права и обязанности в области обработки персональных данных и подтверждаю достоверность предоставленных мною данных. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})